// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__e9w70","imageArea":"styles_imageArea__1DEEn","title":"styles_title__ZAWbg"};